import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import { EngringJobsComp } from "../../components/allPostjobs";
import { AppDispatch, RootState } from "../../store";
import {
  decreasePage,
  getAllPostJobs,
  increasePage,
  jobsPerPage,
} from "../../features/postJob/getAllPostJobsSlice";
import { addQueryParams } from "../../utils/queryParams";
import { Pagination } from "../../components/General/helpers";
import StatCardSkeleton from "../../components/Skeletons/StatCardSkeleton";

const EngineeringJobs = () => {
  const {
    currentPage,
    pageSize,
    totalPages,
    postJobsLoading,
    engineeringPostJobs,
  } = useSelector((store: RootState) => store.allPostJobsStore);

  const [isJobPage, setIsJobPage] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  //
  const handleSaveForLater = () => {
    //
  };

  // Navigate to single job page
  const handleJobDetails = (index: string) => {
    // console.log(index);
    navigate(`/all-post-jobs/${index}`);
  };

  // Go to next page
  const handleNextButton = () => {
    dispatch(increasePage());
  };

  // Go to previous page
  const handlePreviousButton = () => {
    dispatch(decreasePage());
  };

  // Set the number of jobs to see per page
  const handleClickPage = (value: number) => {
    // console.log(value);
    dispatch(jobsPerPage(value));
    setIsJobPage(false);
  };

  // INCLUDE THE URL WITH THE LIMIT AND PAGE NUMBERS
  useEffect(() => {
    addQueryParams(pathname, currentPage, pageSize);
  }, [pathname, currentPage, pageSize]);

  //   Fetch all post jobs
  useEffect(() => {
    dispatch(getAllPostJobs({ isEngineering: true, currentPage, pageSize }));
  }, [currentPage, pageSize, dispatch]);

  if (postJobsLoading) {
    return <StatCardSkeleton />;
  }

  if (engineeringPostJobs.length < 1) {
    return (
      <NoJobsWrapper>
        <p className="no__job">NO ENGINEERING JOBS FOR THIS PAGE</p>
      </NoJobsWrapper>
    );
  }

  return (
    <>
      <EngringJobsComp
        handleJobDetails={handleJobDetails}
        handleSaveForLater={handleSaveForLater}
      />
      <Pagination
        handlePreviousButton={handlePreviousButton}
        handleNextButton={handleNextButton}
        handleClickPage={handleClickPage}
        isJobPage={isJobPage}
        setIsJobPage={setIsJobPage}
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
      />
    </>
  );
};

export default EngineeringJobs;

const NoJobsWrapper = styled.div`
  .no__job {
    font-size: 24px;
    font-weight: bold;
  }
  @media screen and (max-width: 540px) {
    .no__job {
      font-size: 18px;
    }
  }
`;
